import { Star, ShieldCheck, Heart, Mail } from "lucide-react";

const COLUMNS = [
  {
    title: "Watch & Sing",
    links: ["Popular Songs", "Bible Stories", "Bedtime Lullabies", "Movement & Dance"],
  },
  {
    title: "Family",
    links: ["Activities & Printables", "Parent Resources", "Community", "FAMILY+ Membership"],
  },
  {
    title: "Company",
    links: ["Our Mission", "Safety & Privacy", "Shop (coming soon)", "Contact"],
  },
];

const Footer = () => (
  <footer className="relative overflow-hidden bg-slate-900 pt-20 text-slate-300" data-testid="site-footer">
    <Star className="pointer-events-none absolute -left-10 top-10 h-40 w-40 fill-white/[0.03] text-white/[0.03]" aria-hidden="true" />
    <Star className="pointer-events-none absolute right-16 bottom-24 h-24 w-24 fill-white/[0.03] text-white/[0.03]" aria-hidden="true" />
    <div className="relative mx-auto max-w-7xl px-4 sm:px-6">
      <div className="grid gap-12 pb-16 md:grid-cols-5">
        <div className="md:col-span-2">
          <a href="#top" className="flex items-center gap-2" data-testid="footer-logo">
            <span className="grid h-10 w-10 place-items-center rounded-full bg-[#FFC107]">
              <Star className="h-5 w-5 fill-slate-900 text-slate-900" />
            </span>
            <span className="font-display text-xl font-semibold text-white">
              Little Songs. <span className="text-[#FFC107]">Big Faith.</span>
            </span>
          </a>
          <p className="mt-4 max-w-sm text-sm leading-relaxed text-slate-400">
            Christian songs, Bible adventures and joyful activities designed to help families
            make faith part of everyday life.
          </p>
          <p className="mt-5 inline-flex items-center gap-2 rounded-full bg-white/5 px-4 py-2 text-xs font-semibold text-slate-300">
            <ShieldCheck className="h-4 w-4 text-[#4ADE80]" />
            Parent-first accounts &bull; Moderated community &bull; No child DMs
          </p>
          <a
            href="mailto:admin@littlesongsbigfaith.com"
            data-testid="footer-contact-email"
            className="mt-3 inline-flex items-center gap-2 rounded-full bg-white/5 px-4 py-2 text-xs font-semibold text-slate-300 transition-colors hover:text-white"
          >
            <Mail className="h-4 w-4 text-[#FFC107]" />
            admin@littlesongsbigfaith.com
          </a>
        </div>
        {COLUMNS.map((c) => (
          <div key={c.title}>
            <h4 className="font-display text-sm font-semibold uppercase tracking-widest text-[#FFC107]">
              {c.title}
            </h4>
            <ul className="mt-4 space-y-2.5">
              {c.links.map((l) => (
                <li key={l}>
                  <a
                    href={l === "Contact" ? "/contact" : "#top"}
                    data-testid={`footer-link-${l.toLowerCase().replace(/[^a-z]+/g, "-")}`}
                    className="text-sm text-slate-400 transition-colors hover:text-white"
                  >
                    {l}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        ))}
      </div>
      <div className="flex flex-col items-center justify-between gap-4 border-t border-white/10 py-8 text-xs text-slate-500 sm:flex-row">
        <p>&copy; {new Date().getFullYear()} Little Songs. Big Faith. All rights reserved.</p>
        <p className="inline-flex items-center gap-1.5">
          Made with <Heart className="h-3.5 w-3.5 fill-[#FF6B6B] text-[#FF6B6B]" /> for growing hearts
        </p>
      </div>
    </div>
  </footer>
);

export default Footer;
